import React from 'react';
import 'antd/dist/antd.css';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter as Router } from 'react-router-dom';
import { theme } from './theme'
import { MuiThemeProvider } from '@material-ui/core/styles';
import AppLogout from './AppLogout';
import { colors } from './constants/colors';
import { isSessionStale } from './utils/staleSession';
import { forceLogout } from './config/axios';

// Register all color tokens from colors.js as CSS custom properties on <html>.
// Each camelCase key is converted to kebab-case and prefixed with "--color-"
// so components can consume them via var(--color-<name>) in CSS files.
// Example: colors.orangeLighter → --color-orange-lighter
// to avoid allocating an intermediate array, keeping this O(n) with minimal overhead.
// `root` is cached outside the loop to avoid repeated DOM property lookups.
const root = document.documentElement.style;
for (const key in colors) {
  root.setProperty(`--color-${key.replace(/([A-Z])/g, '-$1').toLowerCase()}`, colors[key]);
}

// Browser closed and reopened after the idle limit → log out before anything renders or calls the API.
if (isSessionStale()) {
  forceLogout('autoLogoutMessage'); // Login.tsx shows "you have been logged out"
} else {
  ReactDOM.render(
    <React.StrictMode>
      <MuiThemeProvider theme={theme}>
        <Router>
          <AppLogout>
          <App />
          </AppLogout>
        </Router>
      </MuiThemeProvider>
    </React.StrictMode>,
    document.getElementById('root')
  );
}
  
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();